import React, { useState } from 'react';
import axios from 'axios';
import { Col, Form, Row } from '../ui-kit';

const minLength = 8;
const minScore = 12;
const WEAK = 0,
  OKAY = 2,
  GOOD = 3,
  STRONG = 4;
const scoreWords = [
  I18n.t('passwords.weak'),
  I18n.t('passwords.weak'),
  I18n.t('passwords.okay'),
  I18n.t('passwords.good'),
  I18n.t('passwords.strong')
];
const tooShortWord = I18n.t('passwords.short');
const isTooShort = password => password.length < minLength;

const PasswordInputWithStrengthCheck = () => {
  const [score, setScore] = useState(0);
  const [valid, setValid] = useState(false);
  const [password, setPassword] = useState('');
  const [errorMessages, setErrorMessages] = useState([]);

  const getScore = password => {
    const url = `/api/v2/password/check_strength?password=${password}`;
    axios.get(url).then(response => {
      const { error_messages, accepted, strength } = response.data;

      let score = WEAK;
      if (!accepted) {
        score = WEAK;
      } else if (strength < minScore) {
        score = OKAY;
      } else if (strength > minScore && strength < 18) {
        score = GOOD;
      } else if (strength > 18) {
        score = STRONG;
      }

      setScore(score);
      setErrorMessages(error_messages);
      setValid(strength >= minScore && accepted);
    });
  };

  const handleChange = event => {
    const password = event.target.value;

    if (isTooShort(password)) {
      setScore(0);
    } else {
      // Call the API everytime and check the result
      getScore(password);
    }

    setPassword(password);
  };

  const strengthDesc = isTooShort(password, minLength) ? tooShortWord : scoreWords[score];

  return (
    <>
      <Form.Group as={Row} className="mt-5 mb-3">
        <Form.Label column sm={3}>
          <abbr title="required">*</abbr> {I18n.t('activerecord.attributes.user.password')}
        </Form.Label>
        <Col md={9}>
          <Form.InputGroup hasValidation>
            <Form.Control
              type="password"
              autoComplete="new-password"
              required
              name="user[password]"
              id="user_password"
              onChange={handleChange}
              isInvalid={!valid && password.length > 0}
            />
            <Form.InputGroupText>{strengthDesc}</Form.InputGroupText>
            <Form.ControlFeedback type="invalid">
              {errorMessages.map((e, index) => (
                <p key={index}>{e}</p>
              ))}
            </Form.ControlFeedback>
          </Form.InputGroup>
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3">
        <Form.Label column sm={3}>
          <abbr title="required">*</abbr> {I18n.t('activerecord.attributes.user.password_confirmation')}
        </Form.Label>
        <Col md={9}>
          <Form.Control
            type="password"
            required
            name="user[password_confirmation]"
            id="user_password_confirmation"
            autoComplete="new-password"
          />
        </Col>
      </Form.Group>
    </>
  );
};

export default PasswordInputWithStrengthCheck;
